import { useTheme } from '@mui/material'
import {
  HighlightProps,
  LineHighlight,
} from 'components/Images/Highlights/HighlightTypes'
import { handleSvgHighlightClicked } from 'components/Images/Highlights/handleSvgHighlightClicked'
import { HighlightTooltip } from './HighlightTooltip'

export const LineHeightLight = (props: HighlightProps<LineHighlight>) => {
  const theme = useTheme()

  return (
    <HighlightTooltip {...props}>
      <line
        stroke={theme.palette.warning.dark}
        strokeWidth={10}
        strokeOpacity={0.5}
        x1={props.x1}
        y1={props.y1}
        x2={props.x2}
        y2={props.y2}
        style={{
          cursor: 'pointer',
        }}
        onClick={() =>
          handleSvgHighlightClicked(props.id, props.pdfPage, props.pdfFeature)
        }
      />
    </HighlightTooltip>
  )
}
